export const availableLanguages = ['en', 'uk', 'fr']; // List of supported languages
export const defaultLang = 'uk'; // Default language if no match